import React from 'react'
import LinePriceTagAltIcon from 'components/Luxkit/Icons/line/LinePricetagAltIcon'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import FormatCurrency from 'components/Common/FormatCurrency'

interface Props {
  standardInclusions: Array<App.PackageInclusion>;
  legacyPromotion?: App.CruisePromotionDetails;
}

function CruiseStandardOnboardCreditLabel({ standardInclusions, legacyPromotion } : Props) {
  const onboardCredit = standardInclusions.find(({ parentCategory }) => parentCategory === 'ONBOARD_CREDIT')

  // TODO: Remove support for legacy promotions - https://aussiecommerce.atlassian.net/browse/CRUZ-2646
  const legacyOnboardCredit = legacyPromotion?.onBoardCredit

  return <>
    {!!onboardCredit && <BodyTextBlock
      startIcon={<LinePriceTagAltIcon colour="highlight-secondary" />}
      weight="bold"
      variant="medium"
      colour="highlight-secondary"
    >
      {onboardCredit.description}
    </BodyTextBlock>}
    {!onboardCredit && !!legacyOnboardCredit && <BodyTextBlock
      startIcon={<LinePriceTagAltIcon colour="highlight-secondary" />}
      weight="bold"
      variant="medium"
      colour="highlight-secondary"
    >
      Up to <FormatCurrency currency={legacyOnboardCredit?.currencyCode} value={legacyOnboardCredit?.amount ?? 0} /> onboard credit available
    </BodyTextBlock>}
  </>
}

export default CruiseStandardOnboardCreditLabel
